import React from 'react';
import PropTypes from 'prop-types';


function AnchorStats(props) {
  const { anchor } = props;
  const {
    blog,
    biography,
    Since,
    isNakedNewsLive,
  } = anchor || {};

  return (
    <div className="anchor-pedigree-stats">
      <ul className="list-unstyled">
        {blog && (
          <li>
            <strong>Blog: </strong>
            <a
              href={blog}
              rel="noopener noreferrer"
              target="_blank"
            >
              My blog
            </a>
          </li>
        )}
        {biography.birthdate && (
          <li>
            <strong>Birthday:</strong>&nbsp;
            {biography.birthdate}&nbsp;
          </li>
        )}
        {biography.height && (
          <li>
            <strong>Height:</strong>&nbsp;
            {biography.height}&nbsp;
          </li>
        )}
        {biography.measurements && (
          <li>
            <strong>Measurements:</strong>&nbsp;
            {biography.measurements}&nbsp;
          </li>
        )}
        {biography.specialty && (
          <li>
            <strong>Specialty:</strong>&nbsp;
            {biography.specialty}&nbsp;
          </li>
        )}
        {biography.turnOns && (
          <li>
            <strong>Turn Ons:</strong>&nbsp;
            {biography.turnOns}&nbsp;
          </li>
        )}
        {biography.turnOffs && (
          <li>
            <strong>Turn Offs:</strong>&nbsp;
            {biography.turnOffs}&nbsp;
          </li>
        )}
        {Since && (
          <li>
            <strong>Since:</strong>&nbsp;
            {Since}&nbsp;
          </li>
        )}
        {biography.hobbies && !isNakedNewsLive && (
          <li>
            <strong>Hobbies:</strong>&nbsp;
            {biography.hobbies}&nbsp;
          </li>
        )}
      </ul>
    </div>
  );
}

export default AnchorStats;

AnchorStats.propTypes = { anchor: PropTypes.object.isRequired };
